



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import { IInsuredInfoInput } from '@/modules/Insured/interfaces/insured-form'
import { relationValues, genderValues, includedValues } from '@/modules/Insured/helpers/insured'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppFormCheckbox,
    AppTextarea
  }
})
export default class InsuredFormInfo extends Vue {
  @Prop({ type: Object as () => IInsuredInfoInput }) value!: IInsuredInfoInput

  relationValues = relationValues
  genderValues = genderValues
  includedValues = includedValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
